import { createUseStyles } from "react-jss";
import { colors } from "../../styles/colors";
const useStyles = createUseStyles((_) => ({
  contentMain: {
    overflow: "hidden",
    height: "var(--app-vh)",
  },
  vehiculeRoot: {
    overflowY: "auto",
    // Responsive horizontal padding: compact on narrow, comfortable on wide.
    padding: "20px clamp(16px, 3vw, 30px)",
    height: "var(--app-vh)",
    backgroundColor: colors.bgcolor,
    // Reserve room for the floating hamburger once the rail becomes a drawer.
    "@media (max-width:899.95px)": {
      paddingTop: "68px",
    },
  },
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "30px",
  },
  containerHeader: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    flexWrap: "wrap",
    gap: 12,
    "@media (max-width:899.95px)": {
      flexDirection: "column",
      alignItems: "flex-start",
    },
  },
  subContainer: {
    display: "flex",
    flexDirection: "row",
    gap: 15,
    height: "calc(var(--app-vh) - 140px)",
    overflow: "auto",
  },

  divbuttonHeader: {
    display: "flex",
    flexDirection: "row",
    gap: "15px",
  },
  divLeft: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
  },
  divRight: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    width: "100%",
  },
}));

export default useStyles;
